export const IS_PROFILE_MODAL_OPEN = 'isProfileModalOpen';
export const IS_GAME_INFO_MODAL_OPEN = 'isGameInfoModalOpen';
export const IS_PROGRESSION_ROOM_EDIT_MODAL_OPEN = 'isProgressionRoomEditModalOpen';
export const IS_AUDIT_NOTE_MODAL_OPEN = 'isAuditNoteModalOpen';
export const IS_ENTRY_POINT_CONFIRM_MODAL_OPEN = 'isEntryPointConfirmModalOpen';
export const IS_ENTRY_POINT_SYNC_MODAL_OPEN = 'isEntryPointSyncModalOpen';
